/** @jsx jsx */
import { Box, Grid, Link, Title } from '@bottlebooks/gatsby-theme-base';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/Layout';
import { jsx } from 'theme-ui';
import { Section } from '.';
import useLink from '../useLink';
import RegionCard from './RegionCard';

export default function SanityGroupedRegions({ nodes: regions, locale }) {
  const sortedRegions = [].concat(regions).sort((a, b) => {
    const aValue =
      a.association?.state?.substring(0, 4) + a.name.substring(0, 4);
    const bValue =
      b.association?.state?.substring(0, 4) + b.name.substring(0, 4);
    return aValue > bValue ? 1 : -1;
  });

  const link = useLink();

  const groupedRegions = sortedRegions.reduce((acc, region) => {
    const regionCode = region.regionHierarchy.regionCode;
    if (!acc[regionCode]) acc[regionCode] = { regionCode, regions: [] };
    acc[regionCode].regions.push(region);
    return acc;
  }, {});

  const sortedGroupedRegions = Object.values(groupedRegions).sort((a, b) => {
    return a.regionCode > b.regionCode ? 1 : -1;
  });

  // Different heights are optimal for different numbers of items
  const maxImageHeight = {
    1: 400,
    2: 325,
    3: 275,
  };
  const maxContainerHeight = [
    '70vw',
    '40vw',
    null,
    maxImageHeight[sortedGroupedRegions.length] || 275,
  ];
  const maxCardHeight = [
    '50vw',
    '25vw',
    null,
    maxImageHeight[sortedGroupedRegions.length] * 0.8 || 190,
  ];
  return (
    <Layout page={{ title: 'Regions' }} locale={locale}>
      <Section variant="grey" sx={{ position: 'relative' }}>
        <Title sx={{ paddingY: 4, textAlign: 'center' }}>
          All wine growing areas
        </Title>
        <Grid
          gap={3}
          sx={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          }}
        >
          {sortedGroupedRegions.map((regionGroup) => {
            return (
              <Link to={link.region(regionGroup.regions?.[0]?.regionHierarchy)}>
                <Box
                  sx={{
                    position: 'relative',
                    height: maxContainerHeight,
                  }}
                >
                  <RegionCard
                    region={regionGroup.regions[2]}
                    height={maxCardHeight}
                    sx={{
                      position: 'absolute',
                      left: 20,
                      top: 20,
                      right: 0,
                    }}
                  />
                  <RegionCard
                    region={regionGroup.regions[1]}
                    height={maxCardHeight}
                    sx={{
                      position: 'absolute',
                      left: 10,
                      top: 10,
                      right: 10,
                    }}
                  />
                  <RegionCard
                    region={{
                      ...regionGroup.regions[0],
                      name: regionGroup.regions[0].association?.state,
                    }}
                    height={maxCardHeight}
                    sx={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      right: 20,
                    }}
                  />
                </Box>
              </Link>
            );
          })}
        </Grid>
      </Section>
    </Layout>
  );
}
